import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import api from '../services/api';
import toast from 'react-hot-toast';

const AcceptInvite: React.FC = () => {
  const { token } = useParams<{token:string}>();
  const navigate = useNavigate();
  const [inviteData, setInviteData] = useState<any>(null);
  const [form, setForm] = useState({ firstName:'', lastName:'', password:'', confirm:'' });
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    const check = async () => {
      try {
        const r = await api.get(`/auth/invite/${token}`);
        setInviteData(r.data);
      } catch (e: any) {
        setError(e.response?.data?.error || 'Invitación inválida');
      } finally { setLoading(false); }
    };
    check();
  }, [token]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!form.firstName || !form.lastName || !form.password) { toast.error('Completa todos los campos'); return; }
    if (form.password !== form.confirm) { toast.error('Las contraseñas no coinciden'); return; }
    if (form.password.length < 8) { toast.error('Mínimo 8 caracteres'); return; }
    setSubmitting(true);
    try {
      const r = await api.post('/auth/accept-invite', { token, ...form });
      localStorage.setItem('platform_token', r.data.token);
      toast.success('¡Bienvenido a Zoik Analyst!');
      navigate('/dashboard');
    } catch (e: any) {
      toast.error(e.response?.data?.error || 'Error al activar cuenta');
    } finally { setSubmitting(false); }
  };

  const ROLE_LABELS: any = { ADMIN:'Administrador', CUENTAS:'Cuentas', CONTENIDO:'Contenido', DISENO:'Diseño', ESTRATEGIA:'Estrategia', CLIENTE:'Cliente' };
  const inp = {width:'100%',padding:'10px 12px',borderRadius:'8px',border:'1px solid rgba(38,136,201,0.2)',background:'rgba(38,136,201,0.05)',color:'white',fontSize:'13px',outline:'none',fontFamily:'"Montserrat",sans-serif',boxSizing:'border-box' as const};

  return (
    <div style={{minHeight:'100vh',background:'#060d1a',display:'flex',alignItems:'center',justifyContent:'center',fontFamily:'"Montserrat",sans-serif'}}>
      <div style={{width:'100%',maxWidth:'440px',padding:'0 24px'}}>
        <div style={{textAlign:'center',marginBottom:'32px'}}>
          <div style={{fontSize:'28px',fontWeight:900,color:'white',letterSpacing:'-1px',marginBottom:'6px'}}>ZOIK<span style={{color:'#2688c9'}}>|</span>Analyst</div>
          <div style={{fontSize:'13px',color:'rgba(255,255,255,0.4)'}}>Activar cuenta</div>
        </div>
        {loading ? (
          <div style={{textAlign:'center',color:'rgba(255,255,255,0.4)'}}>Verificando invitación...</div>
        ) : error ? (
          <div style={{background:'rgba(239,68,68,0.1)',border:'1px solid rgba(239,68,68,0.3)',borderRadius:'12px',padding:'24px',textAlign:'center',color:'#f87171'}}>{error}</div>
        ) : (
          <div style={{background:'rgba(255,255,255,0.03)',border:'1px solid rgba(38,136,201,0.2)',borderRadius:'16px',padding:'36px'}}>
            <div style={{background:'rgba(38,136,201,0.1)',border:'1px solid rgba(38,136,201,0.2)',borderRadius:'10px',padding:'14px',marginBottom:'24px'}}>
              <div style={{fontSize:'12px',color:'rgba(255,255,255,0.5)',marginBottom:'4px'}}>Invitación para</div>
              <div style={{fontWeight:700,color:'white',fontSize:'14px'}}>{inviteData?.email}</div>
              <div style={{fontSize:'11px',color:'#2bb0e6',marginTop:'4px'}}>{ROLE_LABELS[inviteData?.role]||inviteData?.role}</div>
            </div>
            <form onSubmit={handleSubmit}>
              <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:'12px',marginBottom:'14px'}}>
                {[['firstName','Nombre'],['lastName','Apellido']].map(([key,label])=>(
                  <div key={key}>
                    <label style={{display:'block',fontSize:'10px',fontWeight:700,color:'rgba(255,255,255,0.4)',textTransform:'uppercase',letterSpacing:'0.8px',marginBottom:'5px'}}>{label}</label>
                    <input value={(form as any)[key]} onChange={e=>setForm(p=>({...p,[key]:e.target.value}))} placeholder={label} style={inp}/>
                  </div>
                ))}
              </div>
              {[['password','Contraseña'],['confirm','Confirmar contraseña']].map(([key,label])=>(
                <div key={key} style={{marginBottom:'14px'}}>
                  <label style={{display:'block',fontSize:'10px',fontWeight:700,color:'rgba(255,255,255,0.4)',textTransform:'uppercase',letterSpacing:'0.8px',marginBottom:'5px'}}>{label}</label>
                  <input type="password" value={(form as any)[key]} onChange={e=>setForm(p=>({...p,[key]:e.target.value}))} placeholder="••••••••" style={inp}/>
                </div>
              ))}
              <button type="submit" disabled={submitting}
                style={{width:'100%',padding:'12px',borderRadius:'9px',border:'none',background:'linear-gradient(135deg,#1e6fa8,#2688c9)',color:'white',fontWeight:700,fontSize:'14px',cursor:'pointer',fontFamily:'"Montserrat",sans-serif',marginTop:'8px',opacity:submitting?0.7:1}}>
                {submitting?'Activando...':'Activar cuenta'}
              </button>
            </form>
          </div>
        )}
      </div>
    </div>
  );
};

export default AcceptInvite;
